/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { ITradePair, ITradePairInterface } from "../ITradePair";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "unlimitedOwner_",
        type: "address",
      },
      {
        internalType: "contract ITradeManager",
        name: "tradeManager_",
        type: "address",
      },
      {
        internalType: "contract IUserManager",
        name: "userManager_",
        type: "address",
      },
      {
        internalType: "contract IFeeManager",
        name: "feeManager_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "enum ITradePair.PositionAlterationType",
        name: "alterationType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "netMargin",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "volume",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
    ],
    name: "AlteredPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "closePrice",
        type: "int256",
      },
    ],
    name: "ClosedPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DepositedBorrowFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "DepositedCloseFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "DepositedOpenFees",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "amount",
        type: "int256",
      },
    ],
    name: "FeeOvercollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "liquidator",
        type: "address",
      },
    ],
    name: "LiquidatedPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "LiquidityGapWarning",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "margin",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "volume",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "size",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "isShort",
        type: "bool",
      },
    ],
    name: "OpenedPosition",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
    ],
    name: "PayedOutCollateral",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedPnL",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedBorrowFeeAmount",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "realizedFundingFeeAmount",
        type: "int256",
      },
    ],
    name: "RealizedPnL",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "protocolPnL",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payout",
        type: "uint256",
      },
    ],
    name: "RegisteredProtocolPnL",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "borrowFeeRate",
        type: "int256",
      },
    ],
    name: "SetBorrowFeeRate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "feeBufferFactor",
        type: "int256",
      },
    ],
    name: "SetFeeBufferFactor",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "liquidatorReward",
        type: "uint256",
      },
    ],
    name: "SetLiquidatorReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "maxExcessRatio",
        type: "int256",
      },
    ],
    name: "SetMaxExcessRatio",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "maxFundingFeeRate",
        type: "int256",
      },
    ],
    name: "SetMaxFundingFeeRate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "maxLeverage",
        type: "uint128",
      },
    ],
    name: "SetMaxLeverage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "minLeverage",
        type: "uint128",
      },
    ],
    name: "SetMinLeverage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "minMargin",
        type: "uint256",
      },
    ],
    name: "SetMinMargin",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "priceFeedAdapter",
        type: "address",
      },
    ],
    name: "SetPriceFeedAdapter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "totalAssetAmountLimit",
        type: "uint256",
      },
    ],
    name: "SetTotalAssetAmountLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "totalVolumeLimit",
        type: "uint256",
      },
    ],
    name: "SetTotalVolumeLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "volumeLimit",
        type: "uint256",
      },
    ],
    name: "SetVolumeLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int256",
        name: "borrowFeeIntegral",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "longFundingFeeIntegral",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "shortFundingFeeIntegral",
        type: "int256",
      },
    ],
    name: "UpdatedFeeIntegrals",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "totalFeeAmount",
        type: "int256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lastNetMargin",
        type: "uint256",
      },
    ],
    name: "UpdatedFeesOfPosition",
    type: "event",
  },
  {
    inputs: [],
    name: "_collateralToPriceMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "absoluteMaintenanceMargin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "addedMargin_",
        type: "uint256",
      },
    ],
    name: "addMarginToPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "closePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "collateral",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collateralToPriceMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "detailsOfPosition",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "id",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "margin",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "volume",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "assetAmount",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "leverage",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "isShort",
            type: "bool",
          },
          {
            internalType: "int256",
            name: "entryPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "liquidationPrice",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentBorrowFeeAmount",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "currentFundingFeeAmount",
            type: "int256",
          },
        ],
        internalType: "struct PositionDetails",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "addedMargin_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "addedLeverage_",
        type: "uint256",
      },
    ],
    name: "extendPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "targetLeverage_",
        type: "uint256",
      },
    ],
    name: "extendPositionToLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeBuffer",
    outputs: [
      {
        internalType: "int256",
        name: "currentBufferAmount",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "bufferFactor",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeIntegral",
    outputs: [
      {
        internalType: "int256",
        name: "longFundingFeeIntegral",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "shortFundingFeeIntegral",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "fundingFeeRate",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "maxExcessRatio",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "borrowFeeIntegral",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "borrowFeeRate",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "lastUpdatedAt",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeManager",
    outputs: [
      {
        internalType: "contract IFeeManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentFundingFeeRates",
    outputs: [
      {
        internalType: "int256",
        name: "longFundingFeeRate",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "shortFundingFeeRate",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCurrentPrices",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "contract IERC20Metadata",
        name: "collateral_",
        type: "address",
      },
      {
        internalType: "contract IPriceFeedAdapter",
        name: "priceFeedAdapter_",
        type: "address",
      },
      {
        internalType: "contract ILiquidityPoolAdapter",
        name: "liquidityPoolAdapter_",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "liquidator_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "liquidatePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidatorReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidityPoolAdapter",
    outputs: [
      {
        internalType: "contract ILiquidityPoolAdapter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxLeverage",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minLeverage",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minMargin",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "margin_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "leverage_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "isShort_",
        type: "bool",
      },
      {
        internalType: "address",
        name: "whitelabelAddress",
        type: "address",
      },
    ],
    name: "openPosition",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "overcollectedFees",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "proportion_",
        type: "uint256",
      },
    ],
    name: "partiallyClosePosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "positionIdToWhiteLabel",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "positionIsLiquidatable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "int256",
        name: "price_",
        type: "int256",
      },
    ],
    name: "positionIsLiquidatableAtPrice",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
    ],
    name: "positionIsShort",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "positionStats",
    outputs: [
      {
        internalType: "uint256",
        name: "totalLongMargin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalLongVolume",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalLongAssetAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShortMargin",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShortVolume",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "totalShortAssetAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceFeedAdapter",
    outputs: [
      {
        internalType: "contract IPriceFeedAdapter",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "positionId_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "removedMargin_",
        type: "uint256",
      },
    ],
    name: "removeMarginFromPosition",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "borrowFeeRate_",
        type: "int256",
      },
    ],
    name: "setBorrowFeeRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "feeBufferFactor_",
        type: "int256",
      },
    ],
    name: "setFeeBufferFactor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "liquidatorReward_",
        type: "uint256",
      },
    ],
    name: "setLiquidatorReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "maxExcessRatio_",
        type: "int256",
      },
    ],
    name: "setMaxExcessRatio",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "maxFundingFeeRate_",
        type: "int256",
      },
    ],
    name: "setMaxFundingFeeRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "maxLeverage_",
        type: "uint128",
      },
    ],
    name: "setMaxLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "minLeverage_",
        type: "uint128",
      },
    ],
    name: "setMinLeverage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minMargin_",
        type: "uint256",
      },
    ],
    name: "setMinMargin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceFeedAdapter",
        name: "priceFeedAdapter_",
        type: "address",
      },
    ],
    name: "setPriceFeedAdapter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "totalVolumeLimit_",
        type: "uint256",
      },
    ],
    name: "setTotalVolumeLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "volumeLimit_",
        type: "uint256",
      },
    ],
    name: "setVolumeLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "syncPositionFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "totalVolumeLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tradeManager",
    outputs: [
      {
        internalType: "contract ITradeManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unlimitedOwner",
    outputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "userManager",
    outputs: [
      {
        internalType: "contract IUserManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "volumeLimit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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__$f2f42d93bfaee14b159d70f3d89c8fa8a6$__9063874ce5c0906064016040805180830381865af41580156107c9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107ed91906159e1565b915091509091565b6107fd611c4e565b82826108098282611ce0565b610811611040565b8361081b81611d5f565b8461082581611e64565b610830878787612012565b610839816121db565b50505050505050565b6003805461084f90615a05565b80601f016020809104026020016040519081016040528092919081815260200182805461087b90615a05565b80156108c85780601f1061089d576101008083540402835291602001916108c8565b820191906000526020600020905b8154815290600101906020018083116108ab57829003601f168201915b505050505081565b6108d86125a2565b600a6108e8620f4240600b615a55565b6108f29190615a96565b6001600160801b0316816001600160801b0316101561096e5760405162461bcd60e51b815260206004820152602d60248201527f5472616465506169723a3a7365744d696e4c657665726167653a204c6576657260448201526c1859d9481d1bdbc81cdb585b1b609a1b60648201526084015b60405180910390fd5b600680546001600160801b0319166001600160801b0383169081179091556040519081527f0a0cbea23b2a09edec19c1fab868f10c2559342e66c801178729fe1505bc3398906020015b60405180910390a150565b6109cb61566c565b6000828152600b6020526040908190209051631281076f60e11b81526004810182905273__$122fb1c45337ab66707031dc9f0774dac0$__906325020ede90602401602060405180830381865af4158015610a2a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a4e9190615abc565b610ab85760405162461bcd60e51b815260206004820152603560248201527f5472616465506169723a3a64657461696c734f66506f736974696f6e3a20506f6044820152741cda5d1a5bdb88191bd95cc81b9bdd08195e1a5cdd605a1b6064820152608401610965565b600080610ad583600901600c9054906101000a900460ff1661261c565b600a85015460018601546040516324f8300560e01b81529395509193506000926001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116936324f8300593610b3693921691600401615ad9565b602060405180830381865afa158015610b53573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610b779190615af2565b600a54610b849190615b0b565b9050610b8e61566c565b8681526040516362f11ee760e11b815260048101869052602481018590526044810184905273__$122fb1c45337ab66707031dc9f0774dac0$__9063c5e23dce90606401602060405180830381865af4158015610bef573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c139190615af2565b60208201526001850154604080830191909152600286015460608301526009860154600160601b900460ff16151560a083015251630365684f60e41b815260048101869052602481018590526044810184905273__$122fb1c45337ab66707031dc9f0774dac0$__9063365684f090606401602060405180830381865af4158015610ca2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cc69190615af2565b6080820152604051633426411760e11b81526004810186905273__$122fb1c45337ab66707031dc9f0774dac0$__9063684c822e90602401602060405180830381865af4158015610d1b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d3f9190615af2565b60c082015260405163450e9ae960e01b81526004810186905260248101859052604481018490526064810183905273__$122fb1c45337ab66707031dc9f0774dac0$__9063450e9ae990608401602060405180830381865af4158015610da9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dcd9190615af2565b60e0820152604051630633555f60e11b8152600481018690526024810185905273__$122fb1c45337ab66707031dc9f0774dac0$__90630c66aabe90604401602060405180830381865af4158015610e29573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e4d9190615af2565b6101008201526040516307a7369360e41b8152600481018690526024810184905273__$122fb1c45337ab66707031dc9f0774dac0$__90637a73693090604401602060405180830381865af4158015610eaa573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ece9190615af2565b6101208201529695505050505050565b610ee66125a2565b806001600160a01b031663ec9c6c306040518163ffffffff1660e01b8152600401602060405180830381865afa158015610f24573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f489190615af2565b610f5390600a615c02565b610f5f6018600a615c02565b610f699190615c0e565b6005556000805462010000600160b01b031916620100006001600160a01b038416021790556040517f0ce47b3ca45a9dd96699d9f861b888671cc5d847f4a82fe252683219c2aeb206906109b890839061570b565b610fc66125a2565b60078190556040518181527f49ec42791c6fc287661930b06d5ae845a2bc030c0edc63db175b4e4092458d5b906020016109b8565b6110036125a2565b61100b611040565b601c8190556040518181527fdcb03c3391d4010c4f8069c2149260316fb2e55610d3f023444c2aac484ca405906020016109b8565b601a546000906110509042615c22565b9050801561125b57604051631194846b60e31b81526014600482015260009073__$f2f42d93bfaee14b159d70f3d89c8fa8a6$__90638ca4235890602401602060405180830381865af41580156110ab573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906110cf9190615af2565b600f546012549192506000916110e59190615b0b565b90506000655af3107a40006110fa8385615c35565b6111049190615c65565b601054601354604051630f36fd3f60e31b8152601460048201526024810192909252604482015290915073__$f2f42d93bfaee14b159d70f3d89c8fa8a6$__906379b7e9f89060640160006040518083038186803b15801561116557600080fd5b505af4158015611179573d6000803e3d6000fd5b50506018546014546015546040517f0e3b245bcd22345199d25ffebece7b72725d8daae0ceb272c4f35274b1c140da95506111c594509283526020830191909152604082015260600190565b60405180910390a1604051637d0663a360e11b8152601b60048201526024810182905260009073__$1eafc50af4bdd18392013238b7c6ca0032$__9063fa0cc74690604401602060405180830381865af4158015611227573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061124b9190615af2565b905061125681612745565b505050505b50565b60008361126a8161282d565b611272611c4e565b61127a611040565b6001600160a01b038316156112b457600d546000908152600c6020526040902080546001600160a01b0319166001600160a01b0385161790555b6112c08787878761296d565b91506112ca612e81565b5095945050505050565b6112dc6125a2565b6112e4611040565b60168190556040518181527f4900b07e48129b1358ac750a3140b78ef8fbd3ea40a96e42379d637ae4e570d8906020016109b8565b611321611c4e565b818161132d8282611ce0565b611335611040565b61133e83611e64565b61134783612fb0565b50505050565b611355611c4e565b8061135f816132a6565b6113cd5760405162461bcd60e51b815260206004820152603960248201527f5472616465506169723a3a6f6e6c794c6971756964617461626c653a20706f736044820152786974696f6e206973206e6f74206c6971756964617461626c6560381b6064820152608401610965565b6113d5611040565b6113de82611e64565b6113e8838361350f565b505050565b6113f56125a2565b6113fd611040565b60178190556040518181527fea4e54f4e6d1179e3f4e4acff9bc235af9444dd11cb6f339189fac46f43b5a85906020016109b8565b600080600060029054906101000a90046001600160a01b03166001600160a01b0316634b8f0bb26040518163ffffffff1660e01b8152600401602060405180830381865afa158015611488573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114ac9190615af2565b600060029054906101000a90046001600160a01b03166001600160a01b03166339b45f306040518163ffffffff1660e01b8152600401602060405180830381865afa1580156114ff573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107ed9190615af2565b6000828152600b60205260408082209051631281076f60e11b81526004810182905273__$122fb1c45337ab66707031dc9f0774dac0$__906325020ede90602401602060405180830381865af4158015611581573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115a59190615abc565b6116215760405162461bcd60e51b815260206004820152604160248201527f5472616465506169723a3a706f736974696f6e49734c6971756964617461626c60448201527f65417450726963653a20706f736974696f6e20646f6573206e6f7420657869736064820152601d60fa1b608482015260a401610965565b60008061163e83600901600c9054906101000a900460ff1661261c565b600a85015460018601546040516324f8300560e01b81529395509193506000926001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116936324f830059361169f93921691600401615ad9565b602060405180830381865afa1580156116bc573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116e09190615af2565b600a546116ed9190615b0b565b60405163f9c7e67560e01b815290915073__$122fb1c45337ab66707031dc9f0774dac0$__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__$122fb1c45337ab66707031dc9f0774dac0$__90632219a1669060640160006040518083038186803b158015611de857600080fd5b505af4158015611dfc573d6000803e3d6000fd5b505050507f317e59f21e39ab9fa6caa2d48947ec7788627fddc0cca2b065edcdd716c8d27b8484600701548560040154611e369190615dd2565b611e3f8661444c565b604080519384526020840192909252908201526060015b60405180910390a150505050565b60646001600160a01b031663a3b1b31d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611ea3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611ec79190615af2565b6000828152600b60205260409020600a0154600160a01b900464ffffffffff1610611f765760405162461bcd60e51b815260206004820152605360248201527f5472616465506169723a3a5f766572696679416e645570646174654c6173744160448201527f6c7465726174696f6e426c6f636b3a20706f736974696f6e20616c726561647960648201527220616c7465726564207468697320626c6f636b60681b608482015260a401610965565b60646001600160a01b031663a3b1b31d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015611fb5573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611fd99190615af2565b6000918252600b6020526040909120600a01805464ffffffffff92909216600160a01b0264ffffffffff60a01b19909216919091179055565b6000828152600b6020526040908190209051634ad00c9760e01b8152600481018290526024810183905273__$122fb1c45337ab66707031dc9f0774dac0$__90634ad00c979060440160006040518083038186803b15801561207357600080fd5b505af4158015612087573d6000803e3d6000fd5b505050506007546120978261444c565b10156121195760405162461bcd60e51b8152602060048201526044602482018190527f5472616465506169723a3a5f72656d6f76654d617267696e46726f6d506f7369908201527f74696f6e3a204d617267696e206d7573742062652061626f7665206d696e4d616064820152633933b4b760e11b608482015260a401610965565b600981015460405163866c742b60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__9163866c742b9161216891600e9187916000918291600160601b900460ff1690600401615df2565b60006040518083038186803b15801561218057600080fd5b505af4158015612194573d6000803e3d6000fd5b505050506121a58483600086614457565b600080516020615fa48339815191526003846121c08461444c565b84600101548560020154604051611e56959493929190615e17565b6000818152600b6020526040908190209051631281076f60e11b81526004810182905273__$122fb1c45337ab66707031dc9f0774dac0$__906325020ede90602401602060405180830381865af415801561223a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061225e9190615abc565b6122d05760405162461bcd60e51b815260206004820152603c60248201527f5472616465506169723a3a5f766572696679506f736974696f6e7356616c696460448201527f6974793a20706f736974696f6e20646f6573206e6f74206578697374000000006064820152608401610965565b6000806122ed83600901600c9054906101000a900460ff1661261c565b915091508273__$122fb1c45337ab66707031dc9f0774dac0$__63f9c7e675909161232a86600901600c9054906101000a900460ff166001614553565b8585612335600a5490565b6040518663ffffffff1660e01b8152600401612355959493929190615c93565b602060405180830381865af4158015612372573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123969190615abc565b156124155760405162461bcd60e51b815260206004820152604360248201527f5472616465506169723a3a5f766572696679506f736974696f6e7356616c696460448201527f6974793a20706f736974696f6e20776f756c64206265206c6971756964617461606482015262626c6560e81b608482015260a401610965565b5050600854600982015473__$122fb1c45337ab66707031dc9f0774dac0$__9063dde8893d90849061245290600160601b900460ff166000614553565b6040516001600160e01b031960e085901b16815260048101929092526024820152604401602060405180830381865af4158015612493573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124b79190615af2565b11156125255760405162461bcd60e51b815260206004820152603760248201527f5472616465506169725f766572696679506f736974696f6e7356616c696469746044820152761e4e88109bdc9c9bddc81b1a5b5a5d081c995858da1959604a1b6064820152608401610965565b60405163800eba2b60e01b815260048101829052611d5b9073__$122fb1c45337ab66707031dc9f0774dac0$__9063800eba2b90602401602060405180830381865af4158015612579573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061259d9190615af2565b61282d565b6125aa614631565b611cde5760405162461bcd60e51b815260206004820152603f60248201527f556e6c696d697465644f776e61626c653a3a5f6f6e6c794f776e65723a20436160448201527f6c6c6572206973206e6f742074686520556e6c696d69746564206f776e6572006064820152608401610965565b601054601354604051632d1aca7b60e01b8152601460048201526024810192909252604482015260009081908190819073__$f2f42d93bfaee14b159d70f3d89c8fa8a6$__90632d1aca7b906064016040805180830381865af4158015612687573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906126ab91906159e1565b915091506000856126bc57826126be565b815b604051634b10170760e11b81526014600482015290915060009073__$f2f42d93bfaee14b159d70f3d89c8fa8a6$__906396202e0e90602401602060405180830381865af4158015612714573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906127389190615af2565b9791965090945050505050565b80156127fd576127757f0000000000000000000000000000000000000000000000000000000000000000826146c6565b6002546040516314c3fb0760e01b81526001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116926314c3fb07926127ca9291909116908590600401615ad9565b600060405180830381600087803b1580156127e457600080fd5b505af11580156127f8573d6000803e3d6000fd5b505050505b6040518181527f1b34f344ee16d756c6caeaf577e0895a8ea5bbfd63ff04e14013fc7bc13361b6906020016109b8565b600654612845906001906001600160801b0316615e5a565b6001600160801b03168110156128d45760405162461bcd60e51b815260206004820152604860248201527f5472616465506169723a3a5f7665726966794c657665726167653a206c65766560448201527f72616765206d7573742062652061626f7665206f7220657175616c206d696e206064820152676c6576657261676560c01b608482015260a401610965565b600654600160801b90046001600160801b031681111561125b5760405162461bcd60e51b815260206004820152604860248201527f5472616465506169723a3a5f7665726966794c657665726167653a206c65766560448201527f72616765206d75737420626520756e646572206f7220657175616c206d6178206064820152676c6576657261676560c01b608482015260a401610965565b60006007548410156129f25760405162461bcd60e51b815260206004820152604260248201527f5472616465506169723a3a5f6f70656e506f736974696f6e3a206d617267696e60448201527f206d7573742062652061626f7665206f7220657175616c206d696e206d61726760648201526134b760f11b608482015260a401610965565b600d80549081906000612a0483615e81565b9190505550612a1586868684614770565b94506000620f4240612a278688615e9a565b612a319190615c0e565b9050600854811115612a9c5760405162461bcd60e51b815260206004820152602e60248201527f5472616465506169723a3a5f6f70656e506f736974696f6e3a20626f72726f7760448201526d081b1a5b5a5d081c995858da195960921b6064820152608401610965565b612aa6878261481b565b60008415612b275760005460405163068bf22760e51b815260048101849052620100009091046001600160a01b03169063d17e44e090602401602060405180830381865afa158015612afc573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b209190615af2565b9050612b9c565b6000546040516371c0857960e01b815260048101849052620100009091046001600160a01b0316906371c0857990602401602060405180830381865afa158015612b75573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b999190615af2565b90505b600080612ba88761261c565b91509150604051806101c001604052808a8152602001858152602001848152602001838152602001600081526020016000815260200182815260200160008152602001600081526020014265ffffffffffff1681526020014265ffffffffffff16815260200188151581526020018b6001600160a01b0316815260200160646001600160a01b031663a3b1b31d6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612c64573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c889190615af2565b64ffffffffff9081169091526000878152600b60209081526040918290208451815590840151600182015583820151600282015560608401516003820155608084015160048083019190915560a0850151600583015560c0850151600683015560e0850151600783015561010085015160088301556101208501516009830180546101408801516101608901511515600160601b0260ff60601b1965ffffffffffff9283166601000000000000026bffffffffffffffffffffffff1990941692909516919091179190911792909216919091179055610180850151600a90920180546101a090960151909416600160a01b026001600160c81b03199095166001600160a01b039092169190911793909317909155516345e17cad60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__916345e17cad91612dd891600e918e918a918a918f9101615df2565b60006040518083038186803b158015612df057600080fd5b505af4158015612e04573d6000803e3d6000fd5b50505050612e11856121db565b604080516001600160a01b038c168152602081018790529081018a9052606081018590526080810184905287151560a08201527f484e73987683b090d2138a0830b7b2201dc339078ea1848897f682dc3a03e70d9060c00160405180910390a1509293505050505b949350505050565b600954600f541115612f185760405162461bcd60e51b815260206004820152605460248201527f5472616465506169723a3a5f636865636b546f74616c566f6c756d654c696d6960448201527f7441667465723a20746f74616c20766f6c756d65206c696d69742072656163686064820152736564206279206c6f6e6720706f736974696f6e7360601b608482015260a401610965565b6009546012541115611cde5760405162461bcd60e51b815260206004820152605560248201527f5472616465506169723a3a5f636865636b546f74616c566f6c756d654c696d6960448201527f7441667465723a20746f74616c20766f6c756d65206c696d697420726561636860648201527465642062792073686f727420706f736974696f6e7360581b608482015260a401610965565b6000818152600b60205260408120908080612fcb8482614933565b9250925092506000612fdc85614b34565b855460018701546002880154600989015460405163866c742b60e01b815294955073__$23335dc1f606a3324a63928b6b1e5c0466$__9463866c742b9461303894600e9491939092600160601b90910460ff1690600401615df2565b60006040518083038186803b15801561305057600080fd5b505af4158015613064573d6000803e3d6000fd5b5050505060008282866130779190615eb1565b6130819190615eb1565b905061308c84612745565b600061309782614c21565b90506130a38682615b0b565b8311156130b7576130b48682615b0b565b92505b82156130dd57600a87015460018801546130dd916001600160a01b03169085908b614457565b6000806130fa89600901600c9054906101000a900460ff1661261c565b600a8b015491935091508a906001600160a01b0316600080516020615f848339815191526131278c614d70565b604051630633555f60e11b8152600481018e90526024810187905273__$122fb1c45337ab66707031dc9f0774dac0$__90630c66aabe90604401602060405180830381865af415801561317e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131a29190615af2565b6040516307a7369360e41b8152600481018f90526024810187905273__$122fb1c45337ab66707031dc9f0774dac0$__90637a73693090604401602060405180830381865af41580156131f9573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061321d9190615af2565b6040805193845260208401929092529082015260600160405180910390a37faedaf11f0369dfc2805b06f27d58ca24ab384b4f45233e6fa011e9330f9c3be38a6132798b600901600c9054906101000a900460ff166001614553565b6040805192835260208301919091520160405180910390a161329a8a614e3f565b50505050505050505050565b6000818152600b60205260408082209051631281076f60e11b81526004810182905273__$122fb1c45337ab66707031dc9f0774dac0$__906325020ede90602401602060405180830381865af4158015613304573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133289190615abc565b61339a5760405162461bcd60e51b815260206004820152603b60248201527f5472616465506169723a3a5f706f736974696f6e49734c69717569646174616260448201527f6c653a20706f736974696f6e20646f6573206e6f7420657869737400000000006064820152608401610965565b6000806133b783600901600c9054906101000a900460ff1661261c565b600a85015460018601546040516324f8300560e01b81529395509193506000926001600160a01b037f00000000000000000000000000000000000000000000000000000000000000008116936324f830059361341893921691600401615ad9565b602060405180830381865afa158015613435573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906134599190615af2565b600a546134669190615b0b565b90508373__$122fb1c45337ab66707031dc9f0774dac0$__63f9c7e67590916134a187600901600c9054906101000a900460ff166001614553565b8686866040518663ffffffff1660e01b81526004016134c4959493929190615c93565b602060405180830381865af41580156134e1573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906135059190615abc565b9695505050505050565b6000818152600b6020526040812090808061352b846001614933565b925092509250600061353c85614b34565b905060008261354b8387615eb1565b6135559190615eb1565b9050600061356282614c21565b90506000600a5482876135759190615b0b565b61357f9190615b0b565b90508481111561359a576135938582615c22565b90506135da565b8094507fab11e5e39f1b93c18ae0cd705d954fb6771ce3b8e9988abf8de8a179604b2194856040516135ce91815260200190565b60405180910390a15060005b600a54811115613604576135f08a600a54614eb4565b600a546135fd9082615c22565b9050613612565b61360e8a82614eb4565b5060005b8381111561364b57600a880154600189015461363a916001600160a01b03169086908c614457565b6136448482615c22565b905061366f565b600a880154600189015461366b916001600160a01b03169083908c614457565b5060005b858111156136915761368086612745565b61368a8682615c22565b905061369e565b61369a81612745565b5060005b8754600189015460028a015460098b015460405163866c742b60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__9463866c742b946136f994600e94929391929091600160601b90910460ff1690600401615df2565b60006040518083038186803b15801561371157600080fd5b505af4158015613725573d6000803e3d6000fd5b505050506000806137468a600901600c9054906101000a900460ff1661261c565b600a8c015491935091508b906001600160a01b0316600080516020615f848339815191526137738d614d70565b604051630633555f60e11b8152600481018f90526024810187905273__$122fb1c45337ab66707031dc9f0774dac0$__90630c66aabe90604401602060405180830381865af41580156137ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906137ee9190615af2565b8e73__$122fb1c45337ab66707031dc9f0774dac0$__637a7369309091886040518363ffffffff1660e01b8152600401613832929190918252602082015260400190565b602060405180830381865af415801561384f573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906138739190615af2565b6040805193845260208401929092529082015260600160405180910390a36040516001600160a01b038d16908c907fd10a9efd7ba8bed5ba24b674500a42d5ec29897baeb7efcaf19e1089fed61ce890600090a36138d08b614e3f565b505050505050505050505050565b6000828152600b602052604090206138fb8483620f424086614770565b60405163f047200160e01b8152600481018390526024810182905290925073__$122fb1c45337ab66707031dc9f0774dac0$__9063f04720019060440160006040518083038186803b15801561395057600080fd5b505af4158015613964573d6000803e3d6000fd5b505060065460405163800eba2b60e01b8152600481018590526001600160801b03909116925073__$122fb1c45337ab66707031dc9f0774dac0$__915063800eba2b90602401602060405180830381865af41580156139c7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906139eb9190615af2565b1015613a6b5760405162461bcd60e51b815260206004820152604360248201527f5472616465506169723a3a5f6164644d617267696e546f506f736974696f6e3a60448201527f204c65766572616765206d7573742062652061626f7665206d696e4c6576657260648201526261676560e81b608482015260a401610965565b60098101546040516345e17cad60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__916345e17cad91613aba91600e9187916000918291600160601b900460ff1690600401615df2565b60006040518083038186803b158015613ad257600080fd5b505af4158015613ae6573d6000803e3d6000fd5b50505050600080516020615fa48339815191526004846121c08461444c565b6000828152600b602052604081206009810154909190613b2f90600160601b900460ff1682614553565b825460018401546002850154600a86015460405163dde8893d60e01b81526004810188905260248101869052949550929391929091613bdb916001600160a01b031690859073__$122fb1c45337ab66707031dc9f0774dac0$__9063dde8893d90604401602060405180830381865af4158015613bb0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613bd49190615af2565b898b61502c565b8555604051638034908160e01b815260048101869052602481018590526044810187905273__$122fb1c45337ab66707031dc9f0774dac0$__9063803490819060640160006040518083038186803b158015613c3657600080fd5b505af4158015613c4a573d6000803e3d6000fd5b50505050600a8501546001860154613c76916001600160a01b031690613c71908590615c22565b61481b565b600e73__$23335dc1f606a3324a63928b6b1e5c0466$__6345e17cad90916000858960010154613ca69190615c22565b858a60020154613cb69190615c22565b60098b015460405160e087901b6001600160e01b0319168152613cea9594939291600160601b900460ff1690600401615df2565b60006040518083038186803b158015613d0257600080fd5b505af4158015613d16573d6000803e3d6000fd5b5050865473__$23335dc1f606a3324a63928b6b1e5c0466$__925063866c742b9150600e90613d459087615c22565b600989015460405160e085901b6001600160e01b0319168152613d7c9392916000918291600160601b900460ff1690600401615df2565b60006040518083038186803b158015613d9457600080fd5b505af4158015613da8573d6000803e3d6000fd5b50505050600080516020615fa4833981519152600288613dc78861444c565b88600101548960020154604051613de2959493929190615e17565b60405180910390a150505050505050565b6000828152600b6020526040812090613e0a61566c565b8254602082015260018301546040820152600283015460608201526000613e3084614d70565b9050600080613e4f86600901600c9054906101000a900460ff1661261c565b604051630633555f60e11b81526004810189905260248101839052919350915060009073__$122fb1c45337ab66707031dc9f0774dac0$__90630c66aabe90604401602060405180830381865af4158015613eae573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613ed29190615af2565b6040516307a7369360e41b8152600481018990526024810184905290915060009073__$122fb1c45337ab66707031dc9f0774dac0$__90637a73693090604401602060405180830381865af4158015613f2f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613f539190615af2565b90508773__$122fb1c45337ab66707031dc9f0774dac0$__636565d2d29091613f8e8b600901600c9054906101000a900460ff166001614553565b6040516001600160e01b031960e085901b16815260048101929092526024820152604481018c9052606401602060405180830381865af4158015613fd6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613ffa9190615af2565b96508760000154866020018181516140129190615c22565b905250600188015460408701805161402b908390615c22565b9052506002880154606087018051614044908390615c22565b90525061405088614d70565b61405a9086615eb1565b945087600401548261406c9190615eb1565b9150600061408161407c87615ed1565b614c21565b90508660200151816140939190615b0b565b8813156140ac5760208701516140a99082615b0b565b97505b60008813156140c5576140c58c8989604001518e614457565b602087015160408089015160608a015160098d0154925163866c742b60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__9463866c742b9461412194600e949293909291600160601b900460ff1690600401615df2565b60006040518083038186803b15801561413957600080fd5b505af415801561414d573d6000803e3d6000fd5b50505050600080516020615fa483398151915260008c61416c8c61444c565b8c600101548d60020154604051614187959493929190615e17565b60405180910390a160408051878152602081018590529081018390528b906001600160a01b038e1690600080516020615f848339815191529060600160405180910390a3505050505050505050505050565b6000838152600b602052604090206141f385848487614770565b92506000620f42406142058486615e9a565b61420f9190615c0e565b905061421b868261481b565b6009820154600090600160601b900460ff16156142ab5760005460405163068bf22760e51b815260048101849052620100009091046001600160a01b03169063d17e44e090602401602060405180830381865afa158015614280573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906142a49190615af2565b9050614320565b6000546040516371c0857960e01b815260048101849052620100009091046001600160a01b0316906371c0857990602401602060405180830381865afa1580156142f9573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061431d9190615af2565b90505b60098301546040516345e17cad60e01b815273__$23335dc1f606a3324a63928b6b1e5c0466$__916345e17cad9161436e91600e918a9188918891600160601b900460ff1690600401615df2565b60006040518083038186803b15801561438657600080fd5b505af415801561439a573d6000803e3d6000fd5b50506040516370d20cc160e01b81526004810186905260248101889052604481018490526064810185905273__$122fb1c45337ab66707031dc9f0774dac0$__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__$1eafc50af4bdd18392013238b7c6ca0032$__92634111c51792601b92909173__$122fb1c45337ab66707031dc9f0774dac0$__90630c66aabe90604401602060405180830381865af41580156149ed573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614a119190615af2565b614a1b9190615dd2565b60088d01546040516307a7369360e41b8152600481018f90526024810189905287919073__$122fb1c45337ab66707031dc9f0774dac0$__90637a73693090604401602060405180830381865af4158015614a7a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614a9e9190615af2565b614aa89190615dd2565b614ab29190615dd2565b6040516001600160e01b031960e087901b1681526004810194909452602484019290925260448301526064820152608401606060405180830381865af4158015614b00573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614b249190615f0e565b9550955095505050509250925092565b6000806000614b5384600901600c9054906101000a900460ff1661261c565b9150915060008473__$122fb1c45337ab66707031dc9f0774dac0$__630295447a9091614b9288600901600c9054906101000a900460ff166001614553565b6040516001600160e01b031960e085901b168152600481019290925260248201526044810186905260648101859052608401602060405180830381865af4158015614be1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614c059190615af2565b905060008113614c16576000614c18565b805b95945050505050565b600080821315614cab57600154600254614c48916001600160a01b03918216911684615468565b60015460405163033c19ab60e41b8152600481018490526001600160a01b03909116906333c19ab090602401600060405180830381600087803b158015614c8e57600080fd5b505af1158015614ca2573d6000803e3d6000fd5b50505050614d32565b6000821215614d32576001546001600160a01b03166388cf36db614cce84615ed1565b6040518263ffffffff1660e01b8152600401614cec91815260200190565b6020604051808303816000875af1158015614d0b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614d2f9190615af2565b90505b60408051838152602081018390527fc1a67890361de13c7f030acb5e10a424429327cf759edea9648e7538010232b9910160405180910390a1919050565b6000806000614d8f84600901600c9054906101000a900460ff1661261c565b915091508373__$122fb1c45337ab66707031dc9f0774dac0$__63dff0c1899091614dcc87600901600c9054906101000a900460ff166001614553565b6040516001600160e01b031960e085901b168152600481019290925260248201526044810185905260648101849052608401602060405180830381865af4158015614e1b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612e799190615af2565b6000908152600b602052604081208181556001810182905560028101829055600381018290556004810182905560058101829055600681018290556007810182905560088101919091556009810180546cffffffffffffffffffffffffff19169055600a0180546001600160c81b0319169055565b6002546040516370a0823160e01b81526001600160a01b03909116906370a0823190614ee490309060040161570b565b602060405180830381865afa158015614f01573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614f259190615af2565b811115615015576001546002546040516370a0823160e01b81526001600160a01b03928316926388cf36db9216906370a0823190614f6790309060040161570b565b602060405180830381865afa158015614f84573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190614fa89190615af2565b614fb29084615c22565b6040518263ffffffff1660e01b8152600401614fd091815260200190565b6020604051808303816000875af1158015614fef573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906150139190615af2565b505b600254611d5b906001600160a01b03168383615468565b604051632b83a48760e01b81526001600160a01b03868116600483015260248201869052604482018590526064820184905260009182917f00000000000000000000000000000000000000000000000000000000000000001690632b83a48790608401602060405180830381865afa1580156150ac573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906150d09190615af2565b90506150dd878285615371565b6150e78187615c22565b979650505050505050565b60008082600701548360040154846000015461510e9190615eb1565b6151189190615eb1565b90506000811361512957600061512b565b805b9392505050565b61515c7f0000000000000000000000000000000000000000000000000000000000000000836146c6565b6002546000828152600c60205260409081902054905163282e4d0f60e11b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081169363505c9a1e936151c49389939283169289921690600401615f3c565b600060405180830381600087803b1580156151de57600080fd5b505af11580156151f2573d6000803e3d6000fd5b505050507f759f566e25a2af022fba6e4179762cbf58ac64ccc76b73b3dc8b711f148ee3a183838360405161522993929190615eed565b60405180910390a1505050565b8015806152b05750604051636eb1769f60e11b81523060048201526001600160a01b03838116602483015284169063dd62ed3e90604401602060405180830381865afa15801561528a573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906152ae9190615af2565b155b61531b5760405162461bcd60e51b815260206004820152603660248201527f5361666545524332303a20617070726f76652066726f6d206e6f6e2d7a65726f60448201527520746f206e6f6e2d7a65726f20616c6c6f77616e636560501b6064820152608401610965565b6113e88363095ea7b360e01b848460405160240161533a929190615ad9565b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b031990931692909217909152615487565b61539b7f0000000000000000000000000000000000000000000000000000000000000000836146c6565b6002546000828152600c6020526040908190205490516366c2fcb560e11b81526001600160a01b037f000000000000000000000000000000000000000000000000000000000000000081169363cd85f96a936154039389939283169289921690600401615f3c565b600060405180830381600087803b15801561541d57600080fd5b505af1158015615431573d6000803e3d6000fd5b505050507f5785d188da074520abcedafcfdabab9cdbab8bc7f57c5aab981cd03cd285199183838360405161522993929190615eed565b6113e88363a9059cbb60e01b848460405160240161533a929190615ad9565b60006154dc826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166155599092919063ffffffff16565b8051909150156113e857808060200190518101906154fa9190615abc565b6113e85760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b6064820152608401610965565b6060612e79848460008585600080866001600160a01b031685876040516155809190615f67565b60006040518083038185875af1925050503d80600081146155bd576040519150601f19603f3d011682016040523d82523d6000602084013e6155c2565b606091505b50915091506150e7878383876060831561563d578251600003615636576001600160a01b0385163b6156365760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e74726163740000006044820152606401610965565b5081612e79565b612e7983838151156156525781518083602001fd5b8060405162461bcd60e51b81526004016109659190615743565b6040518061014001604052806000815260200160008152602001600081526020016000815260200160008152602001600015158152602001600081526020016000815260200160008152602001600081525090565b6001600160a01b038116811461125b57600080fd5b6000806000606084860312156156eb57600080fd5b83356156f6816156c1565b95602085013595506040909401359392505050565b6001600160a01b0391909116815260200190565b60005b8381101561573a578181015183820152602001615722565b50506000910152565b602081526000825180602084015261576281604085016020870161571f565b601f01601f19169190910160400192915050565b60006020828403121561578857600080fd5b81356001600160801b038116811461512b57600080fd5b6000602082840312156157b157600080fd5b5035919050565b600061014082019050825182526020830151602083015260408301516040830152606083015160608301526080830151608083015260a083015161580060a084018215159052565b5060c083015160c083015260e083015160e083015261010080840151818401525061012080840151818401525092915050565b60006020828403121561584557600080fd5b813561512b816156c1565b801515811461125b57600080fd5b600080600080600060a0868803121561587657600080fd5b8535615881816156c1565b94506020860135935060408601359250606086013561589f81615850565b915060808601356158af816156c1565b809150509295509295909350565b600080604083850312156158d057600080fd5b82356158db816156c1565b946020939093013593505050565b600080604083850312156158fc57600080fd5b50508035926020909101359150565b60008060008060006080868803121561592357600080fd5b853567ffffffffffffffff8082111561593b57600080fd5b818801915088601f83011261594f57600080fd5b81358181111561595e57600080fd5b89602082850101111561597057600080fd5b60209283019750955050860135615986816156c1565b92506040860135615996816156c1565b915060608601356158af816156c1565b600080600080608085870312156159bc57600080fd5b84356159c7816156c1565b966020860135965060408601359560600135945092505050565b600080604083850312156159f457600080fd5b505080516020909101519092909150565b600181811c90821680615a1957607f821691505b602082108103615a3957634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b6001600160801b03818116838216028082169190828114615a7857615a78615a3f565b505092915050565b634e487b7160e01b600052601260045260246000fd5b60006001600160801b0383811680615ab057615ab0615a80565b92169190910492915050565b600060208284031215615ace57600080fd5b815161512b81615850565b6001600160a01b03929092168252602082015260400190565b600060208284031215615b0457600080fd5b5051919050565b8082018082111561177757611777615a3f565b600181815b80851115615b59578160001904821115615b3f57615b3f615a3f565b80851615615b4c57918102915b93841c9390800290615b23565b509250929050565b600082615b7057506001611777565b81615b7d57506000611777565b8160018114615b935760028114615b9d57615bb9565b6001915050611777565b60ff841115615bae57615bae615a3f565b50506001821b611777565b5060208310610133831016604e8410600b8410161715615bdc575081810a611777565b615be68383615b1e565b8060001904821115615bfa57615bfa615a3f565b029392505050565b600061512b8383615b61565b600082615c1d57615c1d615a80565b500490565b8181038181111561177757611777615a3f565b80820260008212600160ff1b84141615615c5157615c51615a3f565b818105831482151761177757611777615a3f565b600082615c7457615c74615a80565b600160ff1b821460001984141615615c8e57615c8e615a3f565b500590565b948552602085019390935260408401919091526060830152608082015260a00190565b634e487b7160e01b600052604160045260246000fd5b601f8211156113e857600081815260208120601f850160051c81016020861015615cf35750805b601f850160051c820191505b81811015611be457828155600101615cff565b67ffffffffffffffff831115615d2a57615d2a615cb6565b615d3e83615d388354615a05565b83615ccc565b6000601f841160018114615d725760008515615d5a5750838201355b600019600387901b1c1916600186901b178355611256565b600083815260209020601f19861690835b82811015615da35786850135825560209485019460019092019101615d83565b5086821015615dc05760001960f88860031b161c19848701351681555b505060018560011b0183555050505050565b8082018281126000831280158216821582161715615a7857615a78615a3f565b9485526020850193909352604084019190915260608301521515608082015260a00190565b60a0810160058710615e3957634e487b7160e01b600052602160045260246000fd5b95815260208101949094526040840192909252606083015260809091015290565b6001600160801b03828116828216039080821115615e7a57615e7a615a3f565b5092915050565b600060018201615e9357615e93615a3f565b5060010190565b808202811582820484141761177757611777615a3f565b8181036000831280158383131683831282161715615e7a57615e7a615a3f565b6000600160ff1b8201615ee657615ee6615a3f565b5060000390565b6001600160a01b039390931683526020830191909152604082015260600190565b600080600060608486031215615f2357600080fd5b8351925060208401519150604084015190509250925092565b6001600160a01b03948516815292841660208401526040830191909152909116606082015260800190565b60008251615f7981846020870161571f565b919091019291505056fe8ee87ae700d1675e80de146a53d414ac121318e14212d2caadf712921b549bbcc198725da2f9825f46aaa850a860c2e4ae1dfa2fa9117a2b2b59c6187510b637a264697066735822122039e238e781ed079e0f811b8bf887ff62183316872c2f6263c10565f8bf16fd6864736f6c63430008110033";

type ITradePairConstructorParams =
  | [linkLibraryAddresses: ITradePairLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ITradePairConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class ITradePair__factory extends ContractFactory {
  constructor(...args: ITradePairConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(
        _abi,
        ITradePair__factory.linkBytecode(linkLibraryAddresses),
        signer
      );
    }
  }

  static linkBytecode(
    linkLibraryAddresses: ITradePairLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$f2f42d93bfaee14b159d70f3d89c8fa8a6\\$__", "g"),
      linkLibraryAddresses["src/lib/FeeIntegral.sol:FeeIntegralLib"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$122fb1c45337ab66707031dc9f0774dac0\\$__", "g"),
      linkLibraryAddresses["src/lib/PositionMaths.sol:PositionMaths"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$1eafc50af4bdd18392013238b7c6ca0032\\$__", "g"),
      linkLibraryAddresses["src/lib/FeeBuffer.sol:FeeBufferLib"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$23335dc1f606a3324a63928b6b1e5c0466\\$__", "g"),
      linkLibraryAddresses["src/lib/PositionStats.sol:PositionStatsLib"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(
    unlimitedOwner_: PromiseOrValue<string>,
    tradeManager_: PromiseOrValue<string>,
    userManager_: PromiseOrValue<string>,
    feeManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<ITradePair> {
    return super.deploy(
      unlimitedOwner_,
      tradeManager_,
      userManager_,
      feeManager_,
      overrides || {}
    ) as Promise<ITradePair>;
  }
  override getDeployTransaction(
    unlimitedOwner_: PromiseOrValue<string>,
    tradeManager_: PromiseOrValue<string>,
    userManager_: PromiseOrValue<string>,
    feeManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      unlimitedOwner_,
      tradeManager_,
      userManager_,
      feeManager_,
      overrides || {}
    );
  }
  override attach(address: string): ITradePair {
    return super.attach(address) as ITradePair;
  }
  override connect(signer: Signer): ITradePair__factory {
    return super.connect(signer) as ITradePair__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ITradePairInterface {
    return new utils.Interface(_abi) as ITradePairInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITradePair {
    return new Contract(address, _abi, signerOrProvider) as ITradePair;
  }
}

export interface ITradePairLibraryAddresses {
  ["src/lib/FeeIntegral.sol:FeeIntegralLib"]: string;
  ["src/lib/PositionMaths.sol:PositionMaths"]: string;
  ["src/lib/FeeBuffer.sol:FeeBufferLib"]: string;
  ["src/lib/PositionStats.sol:PositionStatsLib"]: string;
}
